module.exports = __webpack_public_path__ + "resources/images/diploma-421017f8920fb794dee163f317201e24-cache.jpg";